import AlternativeProductCard from './AlternativeProductCard/AlternativeProductCard.js';
import GenericProductCard from './GenericProductCard/GenericProductCard.js';
import { HorizontalProductCard } from './HorizontalProductCard/index.js';
export const ProductCard = {
    Generic: GenericProductCard,
    Alternative: AlternativeProductCard,
    Horizontal: HorizontalProductCard,
};
//# sourceMappingURL=index.js.map